import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

const Contact = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
    e.preventDefault();
    const contactData = {
      li_subject: data.subject,
      li_name: data.name,
      li_email: data.email,
      li_message: data.message,
      li_company: "Visko Group",
    };
    axios
      .post(
        "https://visko.group/api/inquiry/message/insert-message",
        contactData
      )
      .then((response) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${response.data.message}`,
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    reset();
  };
  return (
    <div>
      <section id="contact" class="contact section">
        <div class="container" data-aos="fade">
          <div class="container section-title" data-aos="fade-up">
            <h2>Contact Us</h2>
            <p>Get in touch</p>
          </div>
          <div class="row gy-5 gx-lg-5">
            <div class="col-lg-4">
              <div class="info">
                <h3>Shaping Futures, Fostering Excellence</h3>
                <p>
                  In a world driven by possibilities, the Visko Group emerges as
                  a guiding light, illuminating paths of progress and shaping a
                  future full of promise.
                </p>

                <div class="info-item d-flex">
                  <i class="bi bi-envelope flex-shrink-0"></i>
                  <div>
                    <h4>Email:</h4>
                    <p>info@visko.group</p>
                  </div>
                </div>

                <div class="info-item d-flex">
                  <i class="bi bi-phone flex-shrink-0"></i>
                  <div>
                    <h4>Call:</h4>
                    <p>+91 7828911470</p>
                  </div>
                </div>
                <div class="info-item d-flex">
                  <i class="bi bi-geo-alt flex-shrink-0"></i>
                  <div>
                    <h4>Address:</h4>
                    <p>
                      501-510, 5th floor, B-Zone Business Space, Above Reliance
                      Mart, Nipania Road, Indore, 452010
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-8">
              <form
                onSubmit={handleSubmit(onSubmit)}
                role="form"
                class="php-email-form"
              >
                <div class="row">
                  <div class="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="name"
                      placeholder="Your Name"
                      {...register("name")}
                      required=""
                    />
                    {errors.name && <span>This field is required</span>}
                  </div>
                  <div class="col-md-6 form-group mt-4 mt-md-0">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      {...register("email", { required: true })}
                      required=""
                    />
                    {errors.email && <span>This field is required</span>}
                  </div>
                </div>
                <div class="form-group mt-4">
                  <input
                    type="text"
                    class="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Subject"
                    {...register("subject", { required: true })}
                    required=""
                  />
                  {errors.subject && <span>This field is required</span>}
                </div>
                <div class="form-group mt-4">
                  <textarea
                    class="form-control"
                    name="message"
                    placeholder="Message"
                    {...register("message", { required: true })}
                    required=""
                  ></textarea>
                  {errors.message && <span>This field is required</span>}
                </div>
                <div class="my-4">
                  <div class="loading">Loading</div>
                  <div class="error-message"></div>
                  <div class="sent-message">
                    Your message has been sent. Thank you!
                  </div>
                </div>
                <div class="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
